export const normalizeNumberDefaultValue = (value: unknown): number | undefined => {
  if (value === "" || value == null) return undefined;

  const num = Number(value);
  return Number.isNaN(num) ? undefined : num;
};
